import { useEffect } from 'react';

type UpdateData = {
  message: string;
  // Add more properties as needed
};

type MessageEvent = {
  data: {
    type: string;
    data: UpdateData;
    sender: 'givebacks-shop';
  };
};

const MESSAGE_SENDER = 'givebacks-shop';

const useCartAction = () => {
  const sendUpdateEvent = (data: UpdateData) => {
    window.postMessage({ type: 'UPDATE_CART', data, sender: MESSAGE_SENDER }, '*');
  };

  return sendUpdateEvent;
};

const useSubscribeToCartAction = (handler: (data: UpdateData) => void) => {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data && event.data.sender == MESSAGE_SENDER) {
        if (event.data.type === 'UPDATE_CART') {
          handler(event.data.data);
        }
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [handler]);
};

export { useCartAction, useSubscribeToCartAction };
